import React from 'react';
import { useStyles } from './styles';
import langUtils, { STRING_CONST } from 'containers/language/utils';

type StartNewConversationButtonProps = {
    handleNewConversation: () => void;
    language?: string | null;
};

export default function StartNewConversationButton({
    handleNewConversation,
    language,
}: StartNewConversationButtonProps) {
    const classes = useStyles();

    return (
        <div className={classes.optionsContainer}>
            <div className={classes.optionLabel} style={{ background: '#ffffff' }} onClick={handleNewConversation}>
                {langUtils.getLanguageStr(STRING_CONST.START_NEW_CONVERSATION, language)}
            </div>
        </div>
    );
}
